import { Component, OnInit, HostListener } from "@angular/core";
import { interval, Subscription, combineLatest, Subject } from "rxjs";
import { distinctUntilChanged,takeUntil } from "rxjs/operators";
import { BannerService } from "src/app/services/banner/banner.service";
import { ConfigService } from "src/app/services/config/config.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { AppLinksService } from "src/app/services/applinks/app-links.service";
import { Navigator } from "../../menu/navigator";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { EventsService } from "src/app/services/event/event.service";
import { KeywordsService } from "src/app/services/lobby/keywords.service";
import { Platform } from "@ionic/angular";
import { CashierContentService } from "src/app/services/cashier/cashier-content.service";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { AppstorageTsService } from "src/app/services/appstorage/appstorage.ts.service";
import { OnDepositService } from "src/app/services/on-deposit/on-deposit.service";
import { WebcontentService } from "src/app/services/webcontent/webcontent.service";
@Component({
  selector: "app-banner",
  templateUrl: "./banner.component.html",
  styleUrls: ["./banner.component.scss"],
})
export class BannerComponent implements OnInit {
  public defaultTouch = { x: 0, y: 0, time: 0 };
  public slideData;
  public lobbyName;
  public slides;
  public userLoggedIn;
  public currentSlideData;
  private subscription: Subscription;
  private userLobbySubcriber;
  private interval;
  private isAndroidApp;
  private currentSlide: number = 0;
  _destroy:Subject<any> = new Subject();

  constructor(
    private bannerService: BannerService,
    private utils: UtilsService,
    private config: ConfigService,
    private webcontentService: WebcontentService,
    private appLinks: AppLinksService,
    public events: EventsService,
    private navigator: Navigator,
    private userSessionService: UserSessionService,
    private keywordsService: KeywordsService,
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    private AppStorage: AppstorageTsService,
    private onDepositService:OnDepositService,
    private platform: Platform
  ) {
    this.unSubcribeAll();

    this.userLobbySubcriber = combineLatest([
      this.keywordsService.getKeyword(),
      this.userSessionService.getCustomer().pipe(distinctUntilChanged()),
    ]).pipe(takeUntil(this._destroy)).subscribe(([lobbyName, customer]) => {
      if (lobbyName && customer) {
        this.userLoggedIn = !!customer;
        this.lobbyName = lobbyName;
        this.onGetBanners();
      }
      if (!customer) {
        this.userLoggedIn = customer;
      }
    });
    this.events.subscribe("event:config:reload", () => {
      this.onGetBanners(true);
    });
  }

  ngOnInit() {
    this.userSessionService.isAuthenticated().then(async (auth) => {
      if (!auth) {
        this.userLoggedIn = auth;
        await this.onGetBanners(true);
      }
    });

    this.isAndroidApp = this.platform.is("android");
  }

  private async onGetBanners(logoutState = false) {
    const response = await this.AppStorage.getJurisdiction();
    let jurisdiction = response.value;
    let lobbyName = !!logoutState
      ? `_logoutState${jurisdiction}`
      : this.lobbyName;
    let res: any = await this.bannerService.getBanners(lobbyName);

    if (!res.result) return;

    let banners = res.payload.filter(this.filteredBanners);

    if (banners.length) {
      let clonedBanners = this.utils.clone(banners);
      this.slideData = clonedBanners.map((resData) => {
        resData.banner_image_small =
          this.config.getCampaignBanerImgUrl(resData).sm;
        resData.banner_image_medium =
          this.config.getCampaignBanerImgUrl(resData).md;
        resData.banner_image_large =
          this.config.getCampaignBanerImgUrl(resData).lg;
        return resData;
      });
      this.currentSlideData = this.slideData[this.currentSlide];

      this.startSlideChange();
    }
  }

  changeSlide() {
    if (this.slideData) {
      this.updateCurrentSlideNumber();
      this.currentSlideData = this.slideData[this.currentSlide];
    }
  }
  updateCurrentSlideNumber() {
    this.currentSlide++;
    if (this.currentSlide >= this.slideData.length) this.currentSlide = 0;
  }

  filteredBanners = (banner) => {
    return !!~~banner.show_banner_flag;
  };

  onSliderClick(index) {
    if (this.slideData) {
      this.currentSlideData = this.slideData[index];
    }
  }
  startSlideChange() {
    if (this.slideData) {
      if (this.subscription) this.subscription.unsubscribe();
      this.interval = interval(10000); //1s
      this.subscription = this.interval.subscribe((val) => this.changeSlide());
    }
  }
  onBannerClick(index) {
    if (!this.userLoggedIn) this.onClickLogoutState(index);
    else {
      switch (this.slideData[index].campaign_type) {
        // case "MFREESPIN":
        //   this.navigator.navigateTo("MyFreeSpinComponent");
        //   break;
        case "COUPON_CODE":
          this.navigator.navigateTo(
            "RedeemBonusCodeComponent",
            {},
            { bonusCode: this.slideData[index].campaign_category }
          );
          break;
        case "DEPOSIT":
          this.onDeposit(index);
          break;
        case "REFER_FRIEND":
          this.navigator.navigateTo("RafOverviewComponent");
          break;
        case "ANNOUNCEMENT":
          if (this.slideData[index].banner_action == "URL_EXTERNAL") {
            this.onOpenExternalURL(index);
          }
          else if (this.slideData[index].banner_action == "URL_INTERNAL") {
            this.onOpenInternalURL(index);
          }
          break;
      }
    }
  }

  onOpenExternalURL(index) {
    if (
      this.slideData[index].banner_url !== "" ||
      this.slideData[index].banner_url != null
    ) {
      this.appLinks.openExternalPage(this.slideData[index].banner_url);
    } else {
      return false;
    }
  }

  onOpenInternalURL(index) {
    if (this.slideData[index].banner_url) {
      this.webcontentService.updateExternalLink(this.slideData[index].banner_url);
      this.navigator.toTab("c", false, this.slideData[index].banner_url);
    }
  }

  onClickLogoutState(index) {
    if (this.slideData[index].banner_action == "SIGNUP") {
      this.navigator.navigateTo(
        "SignupStepOneComponent",
        {},
        { signupcode: this.slideData[index].campaign_code }
      );
    } else {
      this.navigator.navigateTo("LoginComponent", { forceModal: true });
    }
  }

  @HostListener("touchstart", ["$event"])
  @HostListener("touchend", ["$event"])
  @HostListener("touchcancel", ["$event"])
  handleTouch(event) {
    let touch = event.touches[0] || event.changedTouches[0];

    // check the events
    if (event.type === "touchstart") {
      this.defaultTouch.x = touch.pageX;
      this.defaultTouch.y = touch.pageY;
      this.defaultTouch.time = event.timeStamp;
    } else if (event.type === "touchend") {
      let deltaX = touch.pageX - this.defaultTouch.x;
      let deltaY = touch.pageY - this.defaultTouch.y;
      let deltaTime = event.timeStamp - this.defaultTouch.time;

      // simulte a swipe -> less than 500 ms and more than 60 px
      if (deltaTime < 500) {
        // touch movement lasted less than 500 ms
        if (Math.abs(deltaX) > 60) {
          // delta x is at least 60 pixels
          if (deltaX > 0) {
            this.doSwipeRight(event);
          } else {
            this.doSwipeLeft(event);
          }
        }

        if (Math.abs(deltaY) > 60) {
          // delta y is at least 60 pixels
          if (deltaY > 0) {
            this.doSwipeDown(event);
          } else {
            this.doSwipeUp(event);
          }
        }
      }
    }
  }

  doSwipeLeft(event) {
    if (!(this.currentSlide - 1 == -1)) {
      this.currentSlide--;
    } else {
      this.currentSlide = this.slideData.length - 1;
    }
    this.currentSlideData = this.slideData[this.currentSlide];
  }

  doSwipeRight(event) {
    if (!(this.currentSlide + 1 == this.slideData.length)) {
      this.currentSlide++;
    } else {
      this.currentSlide = 0;
    }
    this.currentSlideData = this.slideData[this.currentSlide];
  }

  doSwipeUp(event) {
    if (!(this.currentSlide + 1 == this.slideData.length)) {
      this.currentSlide++;
    } else {
      this.currentSlide = 0;
    }
    this.currentSlideData = this.slideData[this.currentSlide];
  }

  doSwipeDown(event) {
    if (!(this.currentSlide - 1 == -1)) {
      this.currentSlide--;
    } else {
      this.currentSlide = this.slideData.length - 1;
    }
    this.currentSlideData = this.slideData[this.currentSlide];
  }
  unSubcribeAll() {
    try {
      this.subscription && this.subscription.unsubscribe();
      this.userLobbySubcriber && this.userLobbySubcriber.unsubscribe();
      this.interval && this.interval.unsubscribe();
    } catch (e) { console.log(e)}
  }
  onDeposit(index): any {
  return this.onDepositService.deposit(this.slideData[index].id);
  }

  ngOnDestroy() {
    this.unSubcribeAll();
    this._destroy.next()
    this._destroy.complete()
  }
}
